// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VWeu","icon":"styles_icon__3xbPE"};